/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

/*
    This file contains the redux tool kit code for the state that the DidYouKnow component uses, the call that is made to obtain data and selector functions that we can call inside of the DidYouKnow component to get access to our state.
*/

// All functions in redux that need to make a call out to a resource need to be created using createAsyncThunk. Reference: https://redux-toolkit.js.org/api/createAsyncThunk -  The thunk action creator function will have plain action creators for the pending, fulfilled, and rejected cases attached as nested fields. You will see that the extraReducers object contains action creators for fetchScarletWellData.fulfilled, fetchScarletWellData.pending, and fetchScarletWellData.rejected. Inside all of these action creators we are updating the state object accordingly.
export const fetchScarletWellData = createAsyncThunk(
  'fetchScarletWellData',
  async () => {
    // const jwtToken = localStorage.getItem('myrJwtToken')
    const res = await axios.get(process.env.REACT_APP_SCARLETWELL_ENDPOINT, {
      headers: {
        // JWT: jwtToken,
      },
    })
    return res.data
  },
)

// This is the initial state object the reducers and extraReducers will change based on whatever we need to change it to. It is required when creating the createSlice object.
const initialState = {
  status: 'idle',
  data: {
    title: 'Scarlet Well',
    image: '',
    content: '',
    events: [],
  },
}

const scarletWellSlice = createSlice({
  name: 'scarletWellWidget',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchScarletWellData.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchScarletWellData.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchScarletWellData.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      state.data.title = action.payload.title
      state.data.image = action.payload.image
      state.data.content = action.payload.content
      state.data.events = action.payload.events
    },
  },
})
// List of selector functions that can be used to access state inside of the DidYouKnow.js Component.
export const selectScarletWellData = (state) => state.scarletWell.data
export const selectScarletWellStatus = (state) => state.scarletWell.status

export default scarletWellSlice.reducer
